module.exports = __webpack_public_path__ + "img/pointer.0ea6576c.png";